// third-party
import { createSlice } from '@reduxjs/toolkit';

// types
import { DefaultRootStateProps } from 'types';

// ----------------------------------------------------------------------

const initialState: DefaultRootStateProps['platfond'] = {
    error: null,
    platfond: [],
    platfondNeg: [],
};

const platfond = createSlice({
    name: 'platfond',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        //GET ALL PLATFOND
        getAllPlatfond(state, action) {
            state.platfond = action.payload;
        },

        //GET ALL PLATFOND
        getAllPlatfondNeg(state, action) {
            state.platfondNeg = action.payload;
        },

        //INSERT NEW PLATFOND
        insertNewPlatfond(state, action) {
            state.platfond.push(action.payload);
        },
    }
});

// Reducer
export default platfond;